/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CatalogPreviewResponseDto } from '../../models/catalog-preview-response-dto';

export interface StoreCatalogsControllerPreviewCatalog$Params {
  storeId: string;
  catalogUrl: string;

  /**
   * Store identifier for multi-tenant requests.
   */
  'terrific-store-id'?: string;
}

export function storeCatalogsControllerPreviewCatalog(
  http: HttpClient,
  rootUrl: string,
  params: StoreCatalogsControllerPreviewCatalog$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<CatalogPreviewResponseDto>> {
  const rb = new RequestBuilder(rootUrl, storeCatalogsControllerPreviewCatalog.PATH, 'get');
  if (params) {
    rb.path('storeId', params.storeId, {});
    rb.query('catalogUrl', params.catalogUrl, {});
    rb.header('terrific-store-id', params['terrific-store-id'], {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CatalogPreviewResponseDto>;
    })
  );
}

storeCatalogsControllerPreviewCatalog.PATH = '/api/v1/stores/{storeId}/catalogs/preview';
